const REQUEST = 'REQUEST'
const SUCCESS = 'SUCCESS'
const FAILURE = 'FAILURE'

export function createRequestTypes(base) {
  const res = {};
  [REQUEST, SUCCESS, FAILURE].forEach(type => res[type] = `${base}_${type}`)  // eslint-disable-line no-return-assign
  return res
}

export function action(type, payload = {}) {
  return { type, ...payload }
}



/** WEBPACK FOOTER **
 ** ./src/utils/actions/actions.js
 **/